export default "__VITE_ASSET__pJJLWcLo__"